<template>
  <div>
    <v-card>
      <v-card-title>Edit My Company</v-card-title>
      <v-card-text>
        <v-row class="mb-1">
          <v-col cols="12" sm="6">
            <v-text-field
              label="Name*"
              required
              outlined
              dense
              v-model="project.name"
              persistent-hint
              hint="Please enter your full company name!"
              hide-details="auto"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Website*"
              required
              outlined
              dense
              v-model="project.website"
              hide-details="auto"
              persistent-hint
              hint="Please enter your company website address"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6">
            <v-select
              label="Type*"
              :items="types"
              v-model="project.type"
              required
              outlined
              dense
              hide-details="auto"
            ></v-select>
          </v-col>

          <v-col cols="12" sm="6">
            <v-text-field
              label="Logo URI"
              required
              outlined
              dense
              v-model="project.logo"
              hide-details="auto"
              persistent-hint
              hint="We will display your logo in the marketplace. If you do not specify a logo, we will use our"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-textarea
              label="Company Description"
              v-model="project.description"
              required
              outlined
              dense
              hide-details="auto"
            ></v-textarea>
          </v-col>
        </v-row>

        <small>*indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="primary" :disabled="!canSave" @click="saveProject">Save</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import Web3 from 'web3'

import { mapGetters, mapState } from 'vuex'
import { mdiContentCopy } from '@mdi/js'

export default {
  data: () => ({
    icons: { mdiContentCopy },
    loading: false,
    types: ['NFT', 'DEFI', 'P2E', 'Metaverse', 'Other'],
    blockchainList: ['BSC', 'POLYGON', 'ETH', 'BSC_TESTNET'],
    project: {
      name: null,
      description: null,
      website: null,
      type: null,
      logo: null,
    },
  }),
  computed: {
    ...mapGetters('web3auth', ['userdata']),
    canSave() {
      return this.project.name && this.project.website && this.project.type
    },
  },
  created() {
    this.project = {
      ...this.project,
      ...this.userdata.project,
    }
  },
  methods: {
    saveProject() {
      if (this.loading) return

      this.loading = true

      this.$http
        .put('/project', this.project)
        .then(({ data }) => {
          if (data.success) {
            this.$store.commit('web3auth/UPDATE_USER', {
              project: this.project,
            })

            this.$store.dispatch(
              'notification/GENERATE_NOTIFICATION',
              {
                type: 'success',
                message: `Project successfully saved!`,
              },
              { root: true },
            )
          }
        })
        .catch(err => {
          if (err.response.data) {
            this.$store.dispatch(
              'notification/GENERATE_NOTIFICATION',
              {
                type: 'error',
                message: err.response.data.message || 'Unknown error!',
              },
              { root: true },
            )
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.v-list-item {
  min-height: 23px !important;
}
</style>
